import clickoutside from '@IM/utils/clickoutside'
export default {
  directives: { clickoutside }
}
